export const TrackOrderCategory = 'Track Order';

export const GaEvents = {
  pageLanding: 'fe_allocstatus_land',
  allocationCancelTripTap: 'fe_allocstatus_alloc_canceltrip_tap',
  allocationCancelConfirmationTap: 'fe_allocstatus_alloc_cancelconf_tap',
  liveCancelTripTap: 'fe_allocstatus_status_canceltrip_tap',
  liveCancelConfirmationTap: 'fe_allocstatus_status_cancelconf_tap',
  contactSupportTap: 'fe_allocstatus_status_support_tap',
  orderDetailsTap: 'fe_allocstatus_bookdetail_tap',
  orderDetailsCloseTap: 'fe_allocstatus_bookdetail_close_tap',
  downloadAppCardTap: 'fe_allocstatus_download_app_tap',
  downloadAppHeaderTap: 'Sticky Download - Top',
  downloadAppHeaderTapParameter: 'Sticky Download - Top_parameter',
  completedOrder: 'fe_allocstatus_orders',
  downloadBarLoaded: 'fe_allocstatus_download_bar_loaded',
  statusDownloadBarLoaded: 'fe_status_download_bar_loaded',
  downloadIllustLoaded: 'fe_allocstatus_download_illust_loaded',
  statusDownloadIllustLoaded: 'fe_status_download_illust_loaded',
  downloadAppTap: 'fe_allocstatus_download_app_tap',
  statusDownloadAppTap: 'fe_status_download_app_tap',
  downloadIllustTap: 'fe_allocstatus_download_app_tap',
  statusDownloadIllustTap: 'fe_status_download_app_tap',
  trackLiveLinkVisible: 'fe_allocstatus_track_order_visible',
  trackLiveLinkClick: 'fe_allocstatus_track_order_tap',
} as const;

export const MoeEvents = {
  pageLandingParameter: 'fe_allocstatus_land_moe',
  allocationCancelTripTapParameter: 'fe_allocstatus_alloc_canceltrip_tap_moe',
  allocationCancelConfirmationTapParameter:
    'fe_allocstatus_alloc_cancelconf_tap_moe',
  liveCancelTripTapParameter: 'fe_allocstatus_status_canceltrip_tap_moe',
  liveCancelConfirmationTapParameter:
    'fe_allocstatus_status_cancelconf_tap_moe',
} as const;

export const bar_attribute = 'Bar';
export const illustration_attribute = 'Illustration';
export const control_group_value = '2';
export const test_group_value = '3';
